import { render } from "./ProgressDialV2.vue?vue&type=template&id=16980016&scoped=true"
import script from "./ProgressDialV2.vue?vue&type=script&lang=js"
export * from "./ProgressDialV2.vue?vue&type=script&lang=js"

import "./ProgressDialV2.vue?vue&type=style&index=0&id=16980016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16980016"]])

export default __exports__